import { useEffect, useMemo, useState } from "react";

import { mapStatVisualizationRooms } from "@/lib/common-utils";
import {
  FetchRoomsResponseDto,
  GetStatServiceGameGroupsResponseDto,
  SysCfgRawDto,
  UserResponseRegularDto,
} from "@/shared/api";

export const useStatVisualizationRooms = ({
  gameGroupsResponse,
  statsRoomsResponse,
  user,
}: {
  gameGroupsResponse?: GetStatServiceGameGroupsResponseDto;
  statsRoomsResponse?: FetchRoomsResponseDto;
  user: UserResponseRegularDto;
}) => {
  const gameGroupsData = useMemo(() => {
    if (!gameGroupsResponse) {
      return {};
    }

    return Object.keys(gameGroupsResponse.rooms).reduce<Record<string, SysCfgRawDto[]>>(
      (acc, key) => {
        acc[key] = gameGroupsResponse.rooms[key].game_groups.map((item) => {
          return {
            name: item,
          };
        });

        return acc;
      },
      {}
    );
  }, [gameGroupsResponse]);

  const statsRoomsData = useMemo(() => statsRoomsResponse?.rooms ?? [], [statsRoomsResponse]);

  const [statVisualizationRooms, setStatVisualizationRooms] = useState(
    mapStatVisualizationRooms(statsRoomsData, gameGroupsData, user)
  );

  useEffect(() => {
    setStatVisualizationRooms(mapStatVisualizationRooms(statsRoomsData, gameGroupsData, user));
  }, [gameGroupsData, statsRoomsData, user]);

  return {
    gameGroupsData,
    statVisualizationRooms,
    setStatVisualizationRooms,
  };
};
